<!--
* @Name：议价审批基本信息
* @Author: 刘玉
* @Date: 2021-12-02 15:43:41
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:41
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.bargainId"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.projectName"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="审批类型：" :value="headInfo.bargainingTypeDict" :options="bargainingTypeOptions"></hi-cell>
    <hi-cell title="采购定价类型：" :value="headInfo.purCategoryTypeDict" :options="purCategoryOptions"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyId" :options="currencyDictOptions"></hi-cell>
    <hi-cell title="是否含税：" :value="headInfo.taxHaveNot" :options="yesNoOptions"></hi-cell>
    <hi-cell title="是否包含模具：" :value="headInfo.isModel" :options="yesNoOptions"></hi-cell>
    <hi-cell title="阶梯价格：" :value="headInfo.stepPriceModeDict" :options="tieredPriceOptions"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    bargainingTypeOptions() {
      return this.$store.getters.dicts.bargaining_type
    },
    purCategoryOptions() {
      return this.$store.getters.dicts.pur_category
    },
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    yesNoOptions() {
      return this.$store.getters.dicts.yes_no
    },
    tieredPriceOptions() {
      return this.$store.getters.dicts.tiered_price
    }
  }
}
</script>
